<template>
  <div class="profit-container container-with-titleBar">
    <TitleBar @poiChangeCallback="poiChangeCallback">
      <div
        v-if="!poiId"
        class="date-picker"
        @click="showDatePicker"
      >
        {{ year + '年' + month + '月' }}
      </div>
    </TitleBar>
    <section
      v-if="!poiId"
      class="profit-overview"
    >
      <div class="top-panel no-border">
        <div class="title single-title">
          <StatusTag
            :status="status"
          >
            门店累计收益
          </StatusTag>
          <span>
            <span> {{ currentIncomeInYuan | priceFormat }}</span>
            <span
              v-if="+currentIncomeInYuan >= 0"
              class="profit"
            >元</span>
          </span>
        </div>
        <div class="desc">
          账单日每月5日
        </div>
      </div>
    </section>
    <section class="profit-overview">
      <div class="top-panel">
        <div class="title single-title">
          <span>{{ poiId ? '门店累计收益' : '各门店明细' }}</span>
          <span v-if="poiId">
            <span> {{ currentIncomeInYuan | priceFormat }}</span>
            <span
              v-if="+currentIncomeInYuan >= 0"
              class="profit"
            >元</span>
          </span>
        </div>
        <div
          v-if="poiId"
          class="desc"
        >
          <p>账单日每月5日</p>
          <p class="warn-tip">
            不包含未出账单
          </p>
        </div>
      </div>
      <div
        v-if="hasCommisionViewAuth"
        class="main-panel"
      >
        <ProfitTable>
          <tbody>
            <tr>
              <th>{{ poiId ? '月份' : '门店' }}</th>
              <th
                class="icon-question"
                @click.stop="showOverviewTip"
              >
                参与分成
              </th>
              <th
                class="icon-question"
                @click.stop="showRateTip"
              >
                比例
              </th>
              <th>
                我的分成
              </th>
              <th>月成本摊销</th>
              <th>月调整款项</th>
              <th>合计</th>
            </tr>
            <tr
              v-for="(poi, index) in poiBillSummaryVOList"
              :key="`${poi.poiId}-${poi.month}`"
              @click="gotoMonthProfit(poi)"
            >
              <td :class="poiId && poi.status ? 'td-large': ''">
                <div class="poi-name">
                  {{ poiId ? poi.month : poi.poiName }}
                </div>
                <StatusTag
                  class="status-tag"
                  :status="poiId && index === 0 ? poi.status : 0"
                />
              </td>
              <td>{{ poi.poiFlowTotalFeeInYuan }}元</td>
              <td>{{ poi.poiBenefitRate }}</td>
              <td>
                {{ poi.poiCurrentIncomeInYuan }}元
              </td>
              <td>{{ poi.poiCostInYuan }}</td>
              <td>{{ poi.poiOtherReviseInYuan }}</td>
              <td>{{ poi.totalInYuan }}</td>
            </tr>
          </tbody>
        </ProfitTable>
      </div>
      <div
        v-else
        class="main-panel"
      >
        <ProfitTable style="width: 100%">
          <tbody>
            <tr>
              <th>{{ poiId ? '月份' : '门店' }}</th>
              <th>
                我的分成
              </th>
            </tr>
            <tr
              v-for="(poi, index) in poiBillSummaryVOList"
              :key="`${poi.poiId}-${poi.month}`"
              @click="gotoMonthProfit(poi)"
            >
              <td :class="poiId && poi.status ? 'td-large': ''">
                <div class="poi-name">
                  {{ poiId ? poi.month : poi.poiName }}
                </div>
                <StatusTag
                  class="status-tag"
                  :status="poiId && index === 0 ? poi.status : 0"
                />
              </td>
              <td>
                {{ poi.poiCurrentIncomeInYuan }}元
                <img
                  class="icon-arrow"
                  src="@/assets/img/arrow-right@2x.png"
                />
              </td>
            </tr>
          </tbody>
        </ProfitTable>
      </div>
    </section>
    <van-popup
      v-model="datePickerFlag"
      round
      position="bottom"
    >
      <van-datetime-picker
        v-model="profitDate"
        type="year-month"
        title="选择月份"
        visible-item-count="3"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="handlePickUp"
        @cancel="datePickerFlag = false"
      />
    </van-popup>
    <TipModal
      v-model="isShowOverviewTip"
      title="参与分成"
      msg="参与分成金额=订单金额-订单退款。数据仅供参考，实际数值以已出账单结算为准。"
    />
    <TipModal
      v-model="isShowRateTip"
      title="比例说明"
      msg="显示最新比例，若当月发生过变更，可进入日账单查看详情"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import DatetimePicker from 'vant/lib/datetime-picker';
import TipModal from '@/components/TipModal';
import TitleBar from '@/components/TitleBar';
import StatusTag from '@/components/StatusTag';
import ProfitTable from '@/components/ProfitTable';
import ProfitApi from '@/api/profit';
import STATUS from '@/constants/status';
import '@/assets/css/page/profit.scss';
import 'vant/lib/datetime-picker/style';

export default {
  name: 'Profit',
  components: {
    TitleBar,
    StatusTag,
    ProfitTable,
    [DatetimePicker.name]: DatetimePicker,
    TipModal,
  },
  data() {
    return {
      poiId: '',
      profitDate: new Date(2021, 7),
      minDate: new Date(2020, 0),
      maxDate: new Date(2021, 7),
      datePickerFlag: false,
      loading: false,
      isShowOverviewTip: false,
      isShowRateTip: false,
      flowTotalFeeInYuan: '',
      currentIncomeInYuan: '',
      poiBillSummaryVOList: [],
      status: 1,
    };
  },
  computed: {
    ...mapState(['currentPoi', 'hasCommisionViewAuth', 'poiList', 'bizlogintoken', 'isAllPois', 'profitMonth']),
    year() {
      return this.profitDate.getFullYear();
    },
    month() {
      return this.profitDate.getMonth() + 1;
    },
  },
  created() {
    if (this.isAllPois) {
      this.setCurrentPoi({
        poiId: '',
        poiName: '全部门店',
      });
    }
  },
  mounted() {
    if (this.profitMonth) {
      const year = this.profitMonth.split('-') && +this.profitMonth.split('-')[0];
      const month = this.profitMonth.split('-') && +this.profitMonth.split('-')[1];
      this.profitDate = new Date(year, month - 1);
      this.setProfitMonth('');
    }
    this.getData();
  },
  methods: {
    ...mapMutations(['setCurrentPoi', 'setAllPois', 'setProfitMonth']),
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`;
      } else {
        return value;
      }
    },
    async getData() {
      const { poiId } = this.currentPoi;
      this.poiId = poiId;
      this.$store.commit('setLoading', true);
      if (!poiId) {
        const res = await ProfitApi.getSummaryByAccDetail(this.year, this.month);
        if (res.respCode === STATUS.SUCCESS) {
          const {
            flowTotalFeeInYuan, currentIncomeInYuan, status, poiBillSummaryVOList,
          } = res.data || {};
          this.flowTotalFeeInYuan = flowTotalFeeInYuan;
          this.currentIncomeInYuan = currentIncomeInYuan;
          this.status = status;
          this.poiBillSummaryVOList = poiBillSummaryVOList;
        }
      } else {
        const res = await ProfitApi.getSummaryMonthList(poiId);
        if (res.respCode === STATUS.SUCCESS) {
          const {
            currentIncomeInYuan, poiBillSummaryVOList,
          } = res.data || {};
          this.currentIncomeInYuan = currentIncomeInYuan;
          this.poiBillSummaryVOList = poiBillSummaryVOList;
        }
      }
      this.$store.commit('setLoading', false);
    },
    showDatePicker() {
      this.datePickerFlag = true;
    },
    handlePickUp() {
      this.datePickerFlag = false;
      this.getData();
    },
    poiChangeCallback() {
      this.getData();
    },
    showOverviewTip() {
      this.isShowOverviewTip = true;
    },
    showRateTip() {
      this.isShowRateTip = true;
    },
    gotoMonthProfit(poi) {
      if (!this.poiId) {
        this.setCurrentPoi(poi);
      }
      this.setAllPois(!this.poiId);
      this.setProfitMonth(poi.month);
      this.$router.push('/monthProfit');
    },
  },
};
</script>
